module.exports = __webpack_public_path__ + "static/media/close.1b7425dc.svg";